import { render } from "./Standuply.vue?vue&type=template&id=3d204c04&scoped=true"
import script from "./Standuply.vue?vue&type=script&lang=js"
export * from "./Standuply.vue?vue&type=script&lang=js"

import "./Standuply.vue?vue&type=style&index=0&id=3d204c04&scoped=true&lang=css"

import exportComponent from "/var/www/compass/production/releases/20251103101657/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3d204c04"]])

export default __exports__